import { FavouritesPayload, isMultipleItemsPayload } from 'utils/pubsub';
import translate from 'utils/translate';

type Input = {
    payload: FavouritesPayload;
    listName?: string;
    itemsQuantity: number;
};

export const getToastText = ({ itemsQuantity, payload, listName }: Input) => {
    const name = listName || translate('DEFAULT_LIST_NAME');

    if (
        isMultipleItemsPayload(payload) &&
        payload.designs?.length === 1 &&
        itemsQuantity === 1
    ) {
        return translate('AGENT_LISTS_ITEM_ADDED', {
            productName: payload.designs[0].configurationId,
            listName: name,
        });
    }
    if (
        isMultipleItemsPayload(payload) &&
        payload.items.length === 1 &&
        itemsQuantity === 1
    ) {
        return translate('AGENT_LISTS_ITEM_ADDED', {
            productName: payload.items[0].productName,
            listName: name,
        });
    }
    if (isMultipleItemsPayload(payload)) {
        return translate('AGENT_LISTS_ALL_ADDED', {
            productQuantity: itemsQuantity.toString(),
            listName: name,
        });
    }
    return translate('AGENT_LISTS_ITEM_ADDED', {
        productName: payload.productName,
        listName: name,
    });
};
